// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"style__iconButton___pVWPN reset__reset___2e25U","iconButton--disabled":"style__iconButton--disabled___2sG1k","size-small":"style__size-small___1mDVh"};